import { useAppSelector } from 'store/hooks'

import { NoticeInState } from './store'

export const useNotification = (): NoticeInState[] | undefined =>
  useAppSelector(store => store.notice.notifications)
